// (key: 日本語, value: 英語)
export const categories = new Map([
    ['ストア・製品', 'store'],
    ['メディア掲載', 'media'],
    ['お風呂ジャーナル', 'journal'],
    ['イベント', 'event'],
])

export const ignoreTags = [
    'ストア',
    'メディア掲載',
    'お風呂ジャーナル',
    'イベント'
]